export const MONTH_BASELINE_PRINT = 1500;

export function planMonths(plan) {
  return Math.max(1, Number(plan?.duration_months ?? plan?.durationMonths ?? 1) || 1);
}

export function planPrice(plan) {
  return Number(plan?.price_pkr ?? plan?.pricePKR ?? plan?.price ?? 0) || 0;
}

export function calcSavingsPct(months, totalPrice) {
  const m = Math.max(1, Number(months) || 1);
  const total = Number(totalPrice) || 0;
  const baseline = MONTH_BASELINE_PRINT * m;
  if (!baseline || total >= baseline) return 0;
  return Math.round(((baseline - total) / baseline) * 100);
}

export function planSavingsPct(plan) {
  return calcSavingsPct(planMonths(plan), planPrice(plan));
}

export function avgPerMonth(total, months) {
  return Math.round((Number(total) || 0) / Math.max(1, Number(months) || 1));
}

export function planAvgPerMonth(plan) {
  return avgPerMonth(planPrice(plan), planMonths(plan));
}

export function formatPkrAmount(n) {
  return `Rs ${(Number(n) || 0).toLocaleString('en-PK')}`;
}

export function durationShortLabel(months) {
  const m = Number(months) || 0;
  if (m === 1) return 'Monthly';
  if (m === 3) return 'Quarterly';
  if (m === 6) return 'Half-Yearly';
  if (m === 12) return 'Yearly';
  if (m === 24) return 'Biennial';
  return `${m} Months`;
}

export function parseFeatures(rawFeatures) {
  if (Array.isArray(rawFeatures)) return rawFeatures.map((s) => String(s).trim()).filter(Boolean);
  if (typeof rawFeatures === 'string') {
    const trimmed = rawFeatures.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) return parsed.map((s) => String(s).trim()).filter(Boolean);
    } catch {
      /* split lines */
    }
    return trimmed.split(/\r?\n|•/).map((s) => s.trim()).filter(Boolean);
  }
  return [];
}

export function maxPlanSavingsPct(plans) {
  if (!Array.isArray(plans) || !plans.length) return 0;
  return plans.reduce((max, plan) => Math.max(max, planSavingsPct(plan)), 0);
}

export function findPlanByMonths(plans, months) {
  if (!Array.isArray(plans)) return null;
  return plans.find((p) => planMonths(p) === Number(months)) || null;
}
